import React from "react"
import { connect } from "react-redux"
import OpenOrderNameModal from "../../components/shop/open-order-name-modal"

const mapStateToProps = state =>({
  isOpen: state.currentShop.openOrders.isNameModalOpen,
})

const mapDispatchToProps = dispatch => ({
  onConfirm: value => dispatch({type: "OPEN_ORDER.NAME_CONFIRMED", payload: {name: value}}),
  onCancel: () => dispatch({type: "OPEN_ORDER.NAME_CANCELLED"})
})

export default connect(mapStateToProps, mapDispatchToProps)(OpenOrderNameModal)
